export enum RunType {
  PRIMARY = 'PRIMARY',
  UPDATE = 'UPDATE',
  EARLY = 'EARLY',
}
